import SplashScreen from './views/SplashScreen';

export default SplashScreen;